const glosbeGlobalState = window.glosbe || { dictionary: {}, auth: { loggedIn: false } };
if (glosbeGlobalState.phrase) {
    // decode html entities
    const doc = new DOMParser().parseFromString(glosbeGlobalState.phrase, "text/html");
    glosbeGlobalState.phrase = doc.documentElement.textContent;
}
export function getGlosbeTransferState() {
    return glosbeGlobalState;
}
export function isLoggedIn() {
    var _a;
    return ((_a = glosbeGlobalState.auth) === null || _a === void 0 ? void 0 : _a.loggedIn) || false;
}
export function getLoginUrl() {
    var _a;
    return ((_a = glosbeGlobalState.auth) === null || _a === void 0 ? void 0 : _a.loginUrl) || '';
}
export function getCardsApiUrl() {
    var _a;
    return ((_a = glosbeGlobalState.cards) === null || _a === void 0 ? void 0 : _a.apiUrl) || "https://cards.glosbe.com/__api";
}
export function getCardsApplicationUrl() {
    var _a;
    return ((_a = glosbeGlobalState.cards) === null || _a === void 0 ? void 0 : _a.appUrl) || "https://cards.glosbe.com";
}
